
import NumberList from "../../../assets/outline/NumberList.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NumberListIcon({ className, dataTestid = "NumberListIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <NumberList data-testid={dataTestid} className={classes} {...rest} />
  );
}
